import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-screen flex items-center">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/089e70b1737fbe5f6951f54641d5b70a.jpg)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#1a2b4a]/90 via-[#1a2b4a]/70 to-[#1a2b4a]/40"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="grid grid-cols-5 gap-12 items-center">
          <div className="col-span-2">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6">
              <i className="ri-checkbox-circle-fill text-white text-sm"></i>
              <span className="text-white text-sm font-medium">Licensed & Bonded Since 2010</span>
            </div>

            <h1 className="text-6xl font-light text-white mb-2 leading-tight">
              Professional Process
            </h1>
            <h1 className="text-6xl font-bold text-white mb-2 leading-tight">
              Serving & Court
            </h1>
            <h1 className="text-6xl font-light text-white mb-6 leading-tight">
              Filing Services
            </h1>

            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              24/7 availability with statewide coverage. Fast, reliable, and professional legal document services you can trust.
            </p>

            <div className="flex items-center gap-4">
              <button className="px-8 py-3.5 bg-[#ff6b35] text-white text-base font-medium rounded-full hover:bg-[#e55a25] transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2">
                Request Service
                <i className="ri-arrow-right-line"></i>
              </button>
              <button className="px-8 py-3.5 bg-transparent border-2 border-white text-white text-base font-medium rounded-full hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap">
                View Services
              </button>
            </div>
          </div>

          <div className="col-span-3 flex justify-end">
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 shadow-2xl max-w-md">
              <div className="space-y-6">
                <div className="border-b border-gray-200 pb-6">
                  <div className="text-5xl font-bold text-[#1a2b4a] mb-2">15,000+</div>
                  <div className="text-sm text-gray-600">Documents Served Annually</div>
                </div>
                <div className="border-b border-gray-200 pb-6">
                  <div className="text-5xl font-bold text-[#1a2b4a] mb-2">98%</div>
                  <div className="text-sm text-gray-600">First-Attempt Success Rate</div>
                </div>
                <div>
                  <div className="text-5xl font-bold text-[#1a2b4a] mb-2">Same-Day</div>
                  <div className="text-sm text-gray-600">Rush Service Available</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
